/**
 * Comprehensive Clinic Management API Service
 * Handles all clinic management features including profile, staff, appointments, 
 * billing, communications, analytics, and settings
 */
import axios from 'axios';
import { API_BASE_URL } from '../../config';

// Use proxy for development, fallback to config
const BASE_URL = process.env.NODE_ENV === 'development' ? '' : API_BASE_URL;
const CLINIC_API = `${BASE_URL}/api/v1/clinics/management`;

// Clinic Profile API
export const clinicProfileApi = {
  // Get clinic profile
  getProfile: async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${CLINIC_API}/profile/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching clinic profile:', error);
      throw error;
    }
  },

  // Update clinic profile
  updateProfile: async (data) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.put(`${CLINIC_API}/update_profile/`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating clinic profile:', error);
      throw error;
    }
  }
};

// Clinic Staff Management API
export const clinicStaffApi = {
  // Get staff list
  getStaff: async (filters = {}) => {
    try {
      const token = localStorage.getItem('accessToken');
      const params = new URLSearchParams(filters);
      const response = await axios.get(`${CLINIC_API}/staff/?${params}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching staff:', error);
      throw error;
    }
  },

  // Add new staff member
  addStaff: async (data) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.post(`${CLINIC_API}/add_staff/`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error adding staff:', error);
      throw error;
    }
  }
};

// Clinic Appointment Management API
export const clinicAppointmentApi = {
  // Get appointments
  getAppointments: async (filters = {}) => {
    try {
      const token = localStorage.getItem('accessToken');
      const params = new URLSearchParams(filters);
      const response = await axios.get(`${CLINIC_API}/appointments/?${params}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching appointments:', error);
      throw error;
    }
  }
};

// Clinic Billing API
export const clinicBillingApi = {
  // Get billing information
  getBilling: async (filters = {}) => {
    try {
      const token = localStorage.getItem('accessToken');
      const params = new URLSearchParams(filters);
      const response = await axios.get(`${CLINIC_API}/billing/?${params}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching billing:', error);
      throw error;
    }
  }
};

// Clinic Communication API
export const clinicCommunicationApi = {
  // Get communications
  getCommunications: async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${CLINIC_API}/communications/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching communications:', error);
      throw error;
    }
  }
};

// Clinic Analytics API
export const clinicAnalyticsApi = {
  // Get analytics data
  getAnalytics: async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${CLINIC_API}/analytics/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching analytics:', error);
      throw error;
    }
  }
};

// Clinic Settings API
export const clinicSettingsApi = {
  // Get settings
  getSettings: async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${CLINIC_API}/settings/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error;
    }
  },

  // Update settings
  updateSettings: async (data) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.put(`${CLINIC_API}/update_settings/`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error;
    }
  }
};

export default {
  clinicProfileApi,
  clinicStaffApi,
  clinicAppointmentApi,
  clinicBillingApi,
  clinicCommunicationApi,
  clinicAnalyticsApi,
  clinicSettingsApi
};


















